import { UnusedSkipTokenOptions } from '@tanstack/react-query'
import {
	GetWithdrawalTransactionsParams,
	WithdrawTransactionResponse,
} from '@/modules/transaction/types'
import bankTransactionService from '../../services'
import { TransactionQueryKeys } from '@/modules/transaction/keys'

export const queryWithdrawTransactionOptions = (
	payload: GetWithdrawalTransactionsParams,
	options?: UnusedSkipTokenOptions<WithdrawTransactionResponse>,
) => ({
	queryKey: [TransactionQueryKeys.WITHDRAW_TRANSACTION, payload],
	queryFn: () => bankTransactionService.getWithdrawalTransactions(payload),
	...options,
})
